module.exports = __webpack_public_path__ + "static/logo24-746e0235d3cf7d1061600cdd5f9d194c.png";